module.exports = __webpack_public_path__ + "img/few_fiveelementk.a7ba86f.png";